import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const userLang = navigator.language.split('-')[0]; // Detecta idioma del navegador (ej: "es", "en")

interface LanguageState {
  language: string;
  dictionary: Record<string, any>;
}

const storedLang = userLang || 'es';

const initialState: LanguageState = {
  //language: storedLang,
  language: '',
  dictionary: {},
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setDictionary: (state, action: PayloadAction<Record<string, any>>) => {
      state.dictionary = action.payload;
    },
  },
});

export const { setLanguage, setDictionary } = languageSlice.actions;
export default languageSlice.reducer;
